import { PROJECT_TYPE, DEPRECATED_PROJECT_TYPE } from './const';

export const clampProjectType = (projectType) => {
  const values = Object.values(PROJECT_TYPE);
  const deprecatedValues = Object.values(DEPRECATED_PROJECT_TYPE);
  if (values.includes(projectType) && !deprecatedValues.includes(projectType)) {
    return projectType;
  }
  return PROJECT_TYPE.facebookAd;
};

export function projectTypeHasSingleAssetType(projectType) {
  return [PROJECT_TYPE.emailSubjectLine, PROJECT_TYPE.sms].includes(projectType);
}

export const isLandingPageBuilderProject = (projectType) => {
  return PROJECT_TYPE.landingPageBuilder === projectType;
};

export const isCanvasProject = (projectType) => {
  return PROJECT_TYPE.canvas === projectType;
};

export const isContinuousOptimizationType = (projectType) => {
  return [PROJECT_TYPE.wtmHomePage, PROJECT_TYPE.continuousOptimization].includes(projectType);
};

export const isDocumentProject = (projectType) => {
  return !isContinuousOptimizationType(projectType) && projectType !== PROJECT_TYPE.blogPostBuilder;
};

export const isProjectTypeLegacy = (type) => Object.values(DEPRECATED_PROJECT_TYPE).includes(type);
